import React, { useEffect, useState } from "react";
import { FaGhost } from "react-icons/fa";
import "./ProductRecycler.css";
import { useNavigate } from "react-router-dom";
import api from "../api";
import Loader from "../components/Loader";
import ScreenTitle from "../components/ScreenTitle";
import OrderCard, { Order } from "../components/Cards/OrderCard";


const OrdersScreen: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState<Order[]>([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchOrders = async () => {
      const response = await api.getOrders();
      console.log("Fetched orders:", response);
      setOrders(response);
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const onBack = () => navigate(-1);

  if (loading)
    return (
      <div className="recycler-loading-state">
        <Loader size="large" type="spinner" text="Loading Orders..." />
      </div>
    );

  return (
    <div className="recycler-canvas">
      <ScreenTitle  onBack={onBack} getHeaderTitle={() => "Orders"} />
      <main className="recycler-main-area">
        <div className="items-list-wrapper">
          {orders.length === 0 ? (
            <div className="empty-state-card">
              <FaGhost className="ghost-icon" />
              <p>Order Something To Display</p>
              <button className="action-btn-black" onClick={onBack}>
                Return to Shop
              </button>
            </div>
          ) : (
            orders.map((order: Order) => (
              <OrderCard key={order.id} order={order} />
            ))
          )}
        </div>
      </main>
    </div>
  );
};

export default OrdersScreen;